export default __webpack_public_path__ + "static/media/step - 4.5ce73b3e.jpeg";